module.exports = __webpack_public_path__ + "static/uber-6bb09d51aa86dcaf048fc29a5c404e65.png";